var cov_20mt0rpxud = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/isInDocument.js",
      hash = "394a1ed4aa771e5c606f97f1aac1b38eff417568",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/dom/isInDocument.js",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 4,
          column: 3
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 30
        }
      },
      "2": {
        start: {
          line: 5,
          column: 2
        },
        end: {
          line: 5,
          column: 51
        }
      }
    },
    fnMap: {
      "0": {
        name: "isInDocument",
        decl: {
          start: {
            line: 1,
            column: 16
          },
          end: {
            line: 1,
            column: 28
          }
        },
        loc: {
          start: {
            line: 1,
            column: 38
          },
          end: {
            line: 6,
            column: 1
          }
        },
        line: 1
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 4,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 4,
            column: 3
          }
        }, {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 4,
            column: 3
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 2,
            column: 6
          },
          end: {
            line: 2,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 6
          },
          end: {
            line: 2,
            column: 13
          }
        }, {
          start: {
            line: 2,
            column: 17
          },
          end: {
            line: 2,
            column: 41
          }
        }],
        line: 2
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export function isInDocument(element) {
  cov_20mt0rpxud.f[0]++;
  cov_20mt0rpxud.s[0]++;

  if ((cov_20mt0rpxud.b[1][0]++, element) && (cov_20mt0rpxud.b[1][1]++, 'isConnected' in element)) {
    cov_20mt0rpxud.b[0][0]++;
    cov_20mt0rpxud.s[1]++;
    return element.isConnected;
  } else {
    cov_20mt0rpxud.b[0][1]++;
  }

  cov_20mt0rpxud.s[2]++;
  return document.documentElement.contains(element);
}